module.exports = __webpack_public_path__ + "img/Cuban_Sandwich_Pork.437cda85.jpg";